__turbopack_context__.v({
  "className": "manrope_bcff28a0-module__zJwyAq__className",
  "variable": "manrope_bcff28a0-module__zJwyAq__variable",
});
